import React, { useContext, useEffect, useState } from "react";
import useFetch from "../Hooks/useFetch";
import useDelete from "../Hooks/useDelete";
import { missionJudgingURL, missionsURL } from "../Hooks/URL";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { userContext } from "../Contexts/userContext";
import useSave from "../Hooks/useSave";
import useUpdate from "../Hooks/useUpdate";
import useFetchWhen from "../Hooks/useFetchWhen";
import MissionJudging from "../Templates/Home/Missions/MissionJudging/MissionJudging";
import { toast } from "react-toastify";
import useEdit from "../Hooks/useEdit";

function MissionJudgingPage() {
  const { contextData, setContextData } = useContext(userContext);
  let { id, teamId } = useParams();
  const location = useLocation();

  // Check if this is an edit operation by looking at the URL path
  const isEdit = location.pathname.includes("/edit");

  const url = `${missionJudgingURL}/${id}/teams/${teamId}/dataForEvaluate`;
  const judgingURL = `${missionJudgingURL}/${id}/teams/${teamId}/scoringReport`;

  const [attributes, setAttributes] = useState({});
  const [team, setTeam] = useState({});

  // If it's edit, fetch the existing report data, otherwise fetch team data for evaluation
  const { data, loading, error } = useFetchWhen(url, !isEdit);
  const {
    data: teamData,
    loading: teamLoading,
    error: teamError,
  } = useFetchWhen(judgingURL, isEdit);

  // useEffect(() => {
  //   if (!loading && !error && data) {
  //     setAttributes(data?.data);
  //   }
  // }, [data, loading, error]);

  useEffect(() => {
    if (!loading && !error && data) {
      setTeam(data?.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    if (!teamLoading && !teamError && teamData) {
      setTeam(teamData?.data);
    }
  }, [teamData, teamLoading, teamError]);

  const navigate = useNavigate();
  const [scores, setScores] = useState([]);
  const [note, setNote] = useState("");
  const [award, setAward] = useState(null);
  const [goSave, setGoSave] = useState(false);
  const [goEdit, setGoEdit] = useState(false);
  const [absent, setAbsent] = useState(false);

  const newObject = absent
    ? {
        absent: true,
      }
    : {
        scoringReportData: {
          note: note,
          scoringReportAttributes: scores,
        },
      };

  // Use useSave for create operations and useUpdate for edit operations
  const { saveState, loading: addLoading } = useSave({
    url: judgingURL,
    goSave: isEdit ? false : goSave,
    setGoSave,
    newObject,
  });

  const { state: updateState, loading: updateLoading } = useEdit(
    judgingURL,
    goEdit,
    setGoEdit,
    newObject
  );

  // Handle success for both create and edit operations
  if (
    saveState.dataRes.status == "success" ||
    updateState.dataRes.status == "success"
  ) {
    navigate(`/missions/${id}`);
  }

  useEffect(() => {
    if ((team?.report && !isEdit) || isEdit) {
      if (isEdit) {
        // For edit mode, populate with existing scores
        setScores(
          team?.groups
            ?.map((group) =>
              group?.attributes?.map((attribute) => ({
                reportAttributeId: attribute?.reportAttributeId,
                value: attribute?.value,
              }))
            )
            ?.flat()
        );
        // Also set the note if it exists
        if (team?.note) {
          setNote(team?.note);
        }
      } else {
        // For create mode, initialize with zero values
        setScores(
          team?.report?.groups
            ?.map((group) =>
              group?.attributes?.map((attribute) => ({
                reportAttributeId: attribute?.id,
                value: 0,
              }))
            )
            ?.flat()
        );
      }
    }
  }, [isEdit, team]);

  const handleSubmit = () => {
    if (
      !scores?.map((item) => item?.value)?.some((item) => item == 0) &&
      note
      // && award
    ) {
      if (isEdit) {
        setGoEdit(true);
      } else {
        setGoSave(true);
      }
    } else
      toast.error("Please check all your inputs are not zeros and note added", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnFocusLoss: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
  };

  return (
    <MissionJudging
      attributes={attributes}
      role={contextData?.role}
      url={judgingURL}
      addLoading={isEdit ? updateLoading : addLoading}
      loading={isEdit ? teamLoading : loading}
      team={team}
      id={id}
      scores={scores}
      setScores={setScores}
      note={note}
      setNote={setNote}
      handleSubmit={handleSubmit}
      setAward={setAward}
      award={award}
      absent={absent}
      setAbsent={setAbsent}
      setGoSave={isEdit ? setGoEdit : setGoSave}
      groups={isEdit ? team?.groups : team?.report?.groups}
      isEdit={isEdit}
    />
  );
}

export default MissionJudgingPage;
